import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "site-header" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "header-content" };
const _hoisted_4 = { class: "nav-menu" };
const _hoisted_5 = { class: "header-tools" };
const _hoisted_6 = {
    key: 0,
    class: "user-dropdown"
};
const _hoisted_7 = { class: "user-btn-name" };
const _hoisted_8 = { class: "dropdown-menu" };
const _hoisted_9 = { class: "mobile-drawer" };
const _hoisted_10 = {
    class: "mobile-menu-panel",
    "aria-label": "主导航"
};
import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { logout } from '@/api/auth';
const siteTitle = 'Software defines the future';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Header',
    setup(__props) {
        /**
         * 网站头部导航组件
         */
        const mobileMenuOpen = ref(false);
        const isDarkMode = ref(false);
        const dropdownOpen = ref(false);
        const router = useRouter();
        const route = useRoute();
        // 路由变化时刷新状态
        const refreshTrigger = ref(0);
        watch(() => route.path, () => {
            refreshTrigger.value++;
            mobileMenuOpen.value = false;
        });
        watch(mobileMenuOpen, (open) => {
            document.body.style.overflow = open ? 'hidden' : '';
        });
        const closeMobileMenu = () => {
            mobileMenuOpen.value = false;
        };
        // 计算是否已登录
        const isLoggedIn = computed(() => {
            refreshTrigger.value; // 依赖刷新触发重新计算
            return !!localStorage.getItem('token');
        });
        // 获取用户信息
        const userInfo = computed(() => {
            refreshTrigger.value; // 依赖刷新触发重新计算
            const userStr = localStorage.getItem('userInfo');
            return userStr ? JSON.parse(userStr) : null;
        });
        const toggleMobileMenu = () => {
            mobileMenuOpen.value = !mobileMenuOpen.value;
        };
        const toggleDarkMode = () => {
            isDarkMode.value = !isDarkMode.value;
            document.documentElement.classList.toggle('dark-mode', isDarkMode.value);
            localStorage.setItem('darkMode', String(isDarkMode.value));
        };
        const toggleSearch = () => {
            router.push('/search');
        };
        const toggleDropdown = () => {
            dropdownOpen.value = !dropdownOpen.value;
        };
        const closeDropdown = () => {
            dropdownOpen.value = false;
        };
        const handleLogout = async () => {
            try {
                const token = localStorage.getItem('token');
                const userId = userInfo.value?.id;
                if (token && userId) {
                    await logout(userId, token);
                }
            }
            catch (error) {
                console.error('登出失败', error);
            }
            finally {
                // 清除本地存储
                localStorage.removeItem('token');
                localStorage.removeItem('userInfo');
                dropdownOpen.value = false;
                // 跳转到首页
                router.push('/');
            }
        };
        // 点击外部关闭下拉菜单
        onMounted(() => {
            // 从本地存储读取深色模式设置
            const savedDarkMode = localStorage.getItem('darkMode');
            if (savedDarkMode === 'true') {
                isDarkMode.value = true;
                document.documentElement.classList.add('dark-mode');
            }
            // 点击外部关闭下拉菜单
            document.addEventListener('click', (e) => {
                const target = e.target;
                if (!target.closest('.user-dropdown')) {
                    dropdownOpen.value = false;
                }
            });
        });
        onUnmounted(() => {
            document.body.style.overflow = '';
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("header", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createCommentVNode(" 网站Logo和标题 "),
                        _createVNode(_component_router_link, {
                            to: "/",
                            class: "brand"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("span", { class: "brand-text" }, _toDisplayString(siteTitle))
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createCommentVNode(" 导航菜单 - 桌面端 "),
                        _createElementVNode("nav", _hoisted_4, [
                            _createVNode(_component_router_link, {
                                to: "/",
                                class: _normalizeClass({ active: _ctx.$route.path === '/' })
                            }, {
                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                        _createTextVNode(" 首页 ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createVNode(_component_router_link, {
                                to: "/article",
                                class: _normalizeClass({ active: _ctx.$route.path.startsWith('/article') })
                            }, {
                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                        _createTextVNode(" 文章 ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createVNode(_component_router_link, {
                                to: "/projects",
                                class: _normalizeClass({ active: _ctx.$route.path.startsWith('/projects') })
                            }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createTextVNode(" 项目 ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createVNode(_component_router_link, {
                                to: "/archive",
                                class: _normalizeClass({ active: _ctx.$route.path.startsWith('/archive') })
                            }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                        _createTextVNode(" 归档 ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createVNode(_component_router_link, {
                                to: "/tags",
                                class: _normalizeClass({ active: _ctx.$route.path.startsWith('/tags') })
                            }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                        _createTextVNode(" 标签 ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createVNode(_component_router_link, {
                                to: "/about",
                                class: _normalizeClass({ active: _ctx.$route.path.startsWith('/about') })
                            }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode(" 关于 ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createVNode(_component_router_link, {
                                to: "/links",
                                class: _normalizeClass({ active: _ctx.$route.path.startsWith('/links') })
                            }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                        _createTextVNode(" 友情链接 ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createCommentVNode(" 用户权限管理（仅登录后可见） "),
                            (isLoggedIn.value)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: "/admin/dashboard",
                                    class: _normalizeClass({ active: _ctx.$route.path.startsWith('/admin') })
                                }, {
                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                            _createTextVNode(" 管理后台 ", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" 右侧工具 "),
                        _createElementVNode("div", _hoisted_5, [
                            _createCommentVNode(" 搜索按钮 "),
                            _createElementVNode("button", {
                                class: "tool-btn",
                                onClick: toggleSearch,
                                title: "搜索"
                            }, " 🔍 "),
                            _createCommentVNode(" 深色模式切换 "),
                            _createElementVNode("button", {
                                class: "tool-btn",
                                onClick: toggleDarkMode,
                                title: "切换深色模式"
                            }, _toDisplayString(isDarkMode.value ? '☀️' : '🌙'), 1 /* TEXT */),
                            _createCommentVNode(" 用户信息（仅登录后可见） "),
                            (isLoggedIn.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        class: "user-btn",
                                        onClick: toggleDropdown
                                    }, [
                                        _cache[8] || (_cache[8] = _createElementVNode("span", {
                                            class: "user-btn-emoji",
                                            "aria-hidden": "true"
                                        }, "👤", -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(userInfo.value?.nickname || userInfo.value?.username), 1 /* TEXT */),
                                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "arrow" }, "▼", -1 /* CACHED */))
                                    ]),
                                    _withDirectives(_createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_router_link, {
                                            to: "/admin/dashboard",
                                            onClick: closeDropdown
                                        }, {
                                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                    _createTextVNode("控制台", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_router_link, {
                                            to: "/admin/user",
                                            onClick: closeDropdown
                                        }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                    _createTextVNode("用户管理", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_router_link, {
                                            to: "/admin/role",
                                            onClick: closeDropdown
                                        }, {
                                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                    _createTextVNode("角色管理", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_router_link, {
                                            to: "/admin/permission",
                                            onClick: closeDropdown
                                        }, {
                                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                    _createTextVNode("权限管理", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }),
                                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "divider" }, null, -1 /* CACHED */)),
                                        _createElementVNode("button", {
                                            class: "logout-btn",
                                            onClick: handleLogout
                                        }, "退出登录")
                                    ], 512 /* NEED_PATCH */), [
                                        [_vShow, dropdownOpen.value]
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" 未登录显示登录链接 "),
                                    _createVNode(_component_router_link, {
                                        to: "/login",
                                        class: "login-link"
                                    }, {
                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode("登录", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                            _createCommentVNode(" 移动端菜单按钮 "),
                            _createElementVNode("button", {
                                class: "menu-toggle",
                                onClick: toggleMobileMenu
                            }, " ☰ ")
                        ])
                    ])
                ]),
                _createCommentVNode(" 移动端侧栏菜单（遮罩 + 抽屉，避免长导航撑开页面） "),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                        class: "mobile-menu-backdrop",
                        onClick: closeMobileMenu
                    }),
                    _createElementVNode("nav", _hoisted_10, [
                        _createVNode(_component_router_link, {
                            to: "/",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                    _createTextVNode("首页", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_router_link, {
                            to: "/article",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                    _createTextVNode("文章", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_router_link, {
                            to: "/search",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                    _createTextVNode("搜索", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_router_link, {
                            to: "/projects",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode("项目", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_router_link, {
                            to: "/archive",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode("归档", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_router_link, {
                            to: "/tags",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode("标签", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_router_link, {
                            to: "/about",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode("关于", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_router_link, {
                            to: "/links",
                            onClick: closeMobileMenu
                        }, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("友情链接", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }),
                        (isLoggedIn.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: "/admin/dashboard",
                                onClick: closeMobileMenu
                            }, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                        _createTextVNode("管理后台", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: "/login",
                                onClick: closeMobileMenu
                            }, {
                                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                        _createTextVNode("登录", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }))
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, mobileMenuOpen.value]
                ])
            ]));
        };
    }
});
